import {
  FetchCacheItemSources,
  FetchItemGqlQuery,
  ID,
  NanoID,
  UUID
} from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';

import { graphQLCacheClient } from '../../graphQLClients';

interface FetchCacheItemProps {
  additionalVariables?: Record<string, unknown>;
  query: FetchItemGqlQuery;
  uuid: UUID | NanoID | ID;
  source?: FetchCacheItemSources;
}

export function fetchCacheItem({
  additionalVariables,
  query,
  uuid,
  source = FetchCacheItemSources.ES
}: FetchCacheItemProps) {
  const { rawName, name } = getQueryName(query);

  productionConsole(
    'log',
    'fetchCacheItem',
    { uuid, source },
    { rawName, name }
  );

  const requestId = generateUuid();

  graphQLCacheClient.addQueryParams(name, requestId);

  return graphQLCacheClient.request(
    query,
    { uuid, source, ...additionalVariables },
    { requestId }
  );
}
